import { isDebug as isDebugMode } from 'OK/utils/environment';

class BannerClickLog {
    constructor() {
    }

    _onclick() {
        OK.logging.logger.success("banner.place", this.place, "click");

        if (isDebugMode) {
            console.info('banner click ' + this.place);
        }
    }

    activate(element) {
        this.place = element.getAttribute("data-place");
        this._onclickHandler = this._onclick.bind(this);
        element.addEventListener("click", this._onclickHandler);
    }

    deactivate(element) {
        element.removeEventListener("click", this._onclickHandler);
    }
}


export default BannerClickLog;
